import Modal from 'react-modal'
import styled from 'styled-components'

import './styles.css'

function CustomModal({ children, show, setOpen }) {
  return (
    <Modal
      isOpen={show}
      className="Modal"
      overlayClassName="Overlay"
      onRequestClose={setOpen ? setOpen : null}
      closeTimeoutMS={200}
    >
      {children}
    </Modal>
  )
}

export default CustomModal

export const ModalBody = styled.div`
  text-align: left !important;
  width: ${(props) => (props.width ? `${props.width}px` : 'auto')};

  .modal-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      font-size: 1.2rem;
      color: ${(props) => props.theme.palette.gray[300]};
      font-weight: bold;
      margin-bottom: 2rem;
    }
  }

  .modal-title {
    font-size: 1.8rem;
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 2rem;
  }

  &.center {
    text-align: center !important;
  }

  .center {
    text-align: center;
  }

  .modal-text {
    font-size: 1.4rem;
    color: ${(props) => props.theme.palette.gray[200]};
    margin-bottom: 2rem;
  }

  .modal-hint {
    display: flex;
    align-items: center;
    background-color: #fff3cd;
    color: #b55e00;
    font-size: 1.4rem;
    padding: 2rem;
    border-radius: 1.6rem;
    width: 100%;

    svg {
      width: 3rem;
      height: 3rem;
      margin-right: 1rem;
    }

    p {
      text-align: center;
    }
  }

  .simple-list {
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 35rem;
    overflow: auto;
    width: 50rem;

    & > li:not(:last-child) {
      border-bottom: 1px solid #e0e0e0;
    }

    .simple-list-item {
      background-color: transparent;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 1.2rem;
      padding: 2rem;
      transition: all 0.2s ease-in-out;
      width: 100%;
      text-align: left;

      &:hover {
        background-color: #f5f5f5;
      }

      &.selected {
        color: ${(props) => props.theme.palette.primary};
        font-weight: 500;
      }
    }
  }

  &.confirmModal {
    color: black;
    text-align: center !important;
    font-size: 1.4rem;
    width: 40rem;

    .icon {
      svg {
        width: 10rem;
        height: 10rem;
        color: ${(props) => props.theme.palette.warning};
      }
    }

    strong {
      font-size: 1.6rem;
      margin: 2rem 0;
      display: block;
    }

    .links-list {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        button {
          background-color: transparent;
          border: 0;
          outline: none;
          cursor: pointer;
          color: ${(props) => props.theme.palette.primary};
          padding: 1rem;
          border-radius: 1.6rem;

          &:hover {
            background-color: #f6f6f6;
          }
        }
      }
    }
  }
`
